<template>
  <div :title="text" :uk-tooltip="tooltipOpts">
    <slot/>
  </div>
</template>

<script>
// See https://getuikit.com/docs/tooltip
export default {
  name: 'tooltip',
  props: {
    text: {
      type: String,
    },
    pos: {
      type: String,
    },
    offset: {
      type: [Boolean, Number],
    },
    animation: {
      type: String,
    },
    duration: {
      type: Number,
    },
    delay: {
      type: Number,
    },
    cls: {
      type: String,
    },
  },
  computed: {
    tooltipOpts() {
      const opts = [];
      if (this.pos) opts.push(`pos: ${this.pos}`);
      if (this.offset) opts.push(`offset: ${this.offset}`);
      if (this.animation) opts.push(`animation: ${this.animation}`);
      if (this.duration) opts.push(`duration: ${this.duration}`);
      if (this.delay) opts.push(`delay: ${this.delay}`);
      if (this.cls) opts.push(`cls: ${this.cls}`);

      return opts.join(';');
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// Tooltip.vue?2edfc418